import { SIZES, DEFAULT_SIZE } from "./values.js"

/**
 * checks if the current switch is active
 *
 * @param {Object} param0
 * @param {number} param0.active index of the active `Switch`
 * @param {number} param0.value index of the current `Switch`
 * @returns {boolean}
 */
export const isSwitchActive = ({ active, value }) => active === value

/**
 * checks if all the nodes in the children array are of type `Switch`
 *
 * @param {Array} children child nodes
 * @returns {boolean}
 */
export const areAllSwitch = (children) =>
  children.every(({ type: { displayName } }) => displayName === "Switch")

/**
 * checks if all the `Switch` nodes passed have unique `value` prop
 *
 * @param {Array} children child nodes
 * @param {number} count number of child nodes
 * @returns {boolean}
 */
export const uniqueValues = (children, count) => {
  const { size } = new Set(children.map(({ props: { value } }) => value))
  return size === count
}

/**
 * Resolves size value
 *
 * Size is mapped to its respective class. Returns the size based on the prop value.
 * @param {string} size value of size prop
 * @param {string} fallback fallback value of size
 * @returns {string}
 */
export const resolvedSize = (size, { fallback = DEFAULT_SIZE } = {}) => {
  if (!size) {
    return { invalid: false, size: fallback }
  }

  if (!SIZES[size]) {
    return { invalid: true, size: fallback }
  }

  return { invalid: false, size }
}
